import { FC } from "react"

import SafeHTMLRenderer from "../../../../safe-html-renderer"
import { formatDateTimeFromISO } from "../../../../../utils"
import { SubscriptionChatMessage } from "../../../../../../types"

interface EngagementChatSystemProps {
  messageData: SubscriptionChatMessage
}

const EngagementChatSystem: FC<EngagementChatSystemProps> = ({
  messageData
}) => (
  <div className="w-full flex flex-row-reverse my-1">
    <div className="flex flex-col max-w-[75%]">
      <SafeHTMLRenderer
        htmlContent={messageData.message}
        className="bg-purple-400 text-white p-3 shadow-md rounded"
      />
      <div className="pt-1 text-xs text-right text-gray-400">
        {formatDateTimeFromISO(messageData.timestamp)}
      </div>
    </div>
  </div>
)

export default EngagementChatSystem
